export default __webpack_public_path__ + "static/media/tower_cover.6840ae91.jpg";